import React, { useState } from 'react'
import { Button, Col, Drawer, notification, Row, DatePicker } from 'antd'
import {
  editWithdrawalLimitDateFxn
} from '../actions/user'
import { useDispatch } from 'react-redux'
import { InputBox } from '../../../components/_utils/appUtils'

const UsedLimitWithdrawalDate = (props) => {
  const { visible, onClose, record } = props
  const dispatch = useDispatch()
  const [date, setDate] = useState('')


  const handleSubmit = async () => {

    if (!date) {
      return notification.warning({
        message: 'Please Choose Date'
      })
    }
    let valData = {
      newWithdrawalReleaseDate: date,
      withdrawalLimitId: record._id
    }

    const resp = await dispatch(editWithdrawalLimitDateFxn(valData))
    if (resp.success) {
      onClose()
    }
  }


  return (
    <Drawer
      title='Edit Withdrawal Release Date'
      width='20%'
      onClose={onClose}
      visible={visible}
    >
      <div className='card'>
        <Row className={'ml10'} gutter={16}>
          <Col>
            <InputBox title={'Choose Date'}>
              <DatePicker
                value={date}
                className={'form-control'}
                placeholder='Choose Withdrawal Release Date'
                onChange={(value) => setDate(value)}
              />
            </InputBox>
          </Col>
          <Col span={16}>
            <Button
              type='primary'
              htmlType='submit'
              className='btn btn-success-dark'
              onClick={handleSubmit}
            >
              Update
            </Button>
          </Col>
        </Row>
      </div>
    </Drawer>
  )
}

export default UsedLimitWithdrawalDate